import FrowningFace from "@/assets/icons/sentiment-negative.svg";
import NeutralFace from "@/assets/icons/sentiment-neutral.svg";
import HappyFace from "@/assets/icons/sentiment-positive.svg";
import VeryNegative from "@/assets/icons/sentiment-very-negative.svg";
import VeryPositive from "@/assets/icons/sentiment-very-positive.svg";
import { SENTIMENT as _SENTIMENT } from "@/constants";
import { msg } from "@lingui/core/macro";

export const SENTIMENT = {
  very_positive: {
    value: _SENTIMENT.VERY_POSITIVE,
    label: msg`Väldigt positivt`,
    pluralLabel: msg`Väldigt positiva`,
    icon: VeryPositive,
  },
  positive: {
    value: _SENTIMENT.POSITIVE,
    label: msg`Positivt`,
    pluralLabel: msg`Positiva`,
    icon: HappyFace,
  },
  neutral: {
    value: _SENTIMENT.NEUTRAL,
    label: msg`Neutralt`,
    pluralLabel: msg`Neutrala`,
    icon: NeutralFace,
  },
  negative: {
    value: _SENTIMENT.NEGATIVE,
    label: msg`Negativt`,
    pluralLabel: msg`Negativa`,
    icon: FrowningFace,
  },
  very_negative: {
    value: _SENTIMENT.VERY_NEGATIVE,
    label: msg`Väldigt negativt`,
    pluralLabel: msg`Väldigt negativa`,
    icon: VeryNegative,
  },
};

export const SENTIMENT_OPTIONS = [
  SENTIMENT.very_positive,
  SENTIMENT.positive,
  SENTIMENT.neutral,
  SENTIMENT.negative,
  SENTIMENT.very_negative,
];
